import { makeStyles, shorthands } from "@fluentui/react-components";
import * as React from "react";
import type { Article } from "../data";

const useStyles = makeStyles({
  root: {
    backgroundSize: "100% 100%",
    height: "232px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    backgroundPositionX: "center",
    ...shorthands.border("none"),
    ...shorthands.textDecoration("none"),

    "@media (min-width: 513px) and (max-width: 953px)": {
      height: "150px",
    },
    "@media (max-width: 512px)": {
      height: "92px",
    },
  },
  titleStyle: {
    width: "100%",
    color: "#004578",
    textAlign: "center",
    fontFamily: "Segoe UI Variable",
    fontSize: "80px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "115%",
    "@media (max-width: 512px)": {
      fontSize: "28px",
      lineHeight: "128.571%",
    },
  },
});

export const BannerImage: React.FC<{
  title: string;
  article: Article;
}> = ({ article, title }) => {
  const styles = useStyles();
  return (
    <div
      style={{ backgroundImage: `url("${article.imgSrc}")` }}
      className={styles.root}
      data-testid="banner-image"
    >
      <span className={styles.titleStyle}>{title}</span>
    </div>
  );
};
